import moment from 'moment';

export default class DateHelper {
  static isValidDate(date, earliestAllowableDate = '1899-12-31') {
    let formattedDate = moment(date).format('YYYY-MM-DD');
    if (!moment(formattedDate).isValid() && isNaN(date)) {
      return false;
    }
    return moment(formattedDate).isValid() && moment(formattedDate).isAfter(earliestAllowableDate);
  }

  static isStartDateAfterEndDate(startDate, endDate) {
    return moment(startDate).isAfter(moment(endDate));
  }

  static sortObjectsByDateDescending(arrayOfObjects, key) {
    return arrayOfObjects?.sort((a, b) => {
      return moment(a[key])?.isAfter(moment(b[key])) ? -1 : moment(a[key])?.isBefore(moment(b[key])) ? 1 : 0;
    });
  }

  static convertUsToIsoDate(usDate) {
    if (usDate === undefined || usDate === null || usDate === '') {
      return usDate;
    }
    let dateParts = usDate.split('/');
    if (dateParts[0].length !== 2 || dateParts[1].length !== 2 || dateParts[2].length !== 4) {
      throw new Error('Invalid date format.  Must be MM/DD/YYYY.');
    }
    return `${dateParts[2]}-${dateParts[0]}-${dateParts[1]}`;
  }

  static convertIntSecondsToDate(seconds, format) {
    if (seconds == null) {
      return '';
    }

    let dateMoment = moment.unix(seconds).local();

    switch (format) {
      case 'noHours':
        return dateMoment.format('MM/DD/YYYY');
      default:
        return '';
    }
  }
}
